module.exports = __webpack_public_path__ + "static/media/JiJiJi_EN.a34fc43c.png";